import Vue from 'vue'


Vue.prototype.exitAccount = function () {
	console.log('准备退出了， 对仓库进行更新 清除所有东西! ')
	this.$store.commit('updateAll', {token: '', token_time: '', user_id: '', userType: '', isRuHui: '', hasQiYe: '', isShenHe: '', userName: '', })
	console.log('清除本地存储')
	this.setLocalObj('xianggangzhongxie', {token: '', token_time: '', user_id: '', userType: '', isRuHui: '', hasQiYe: '', isShenHe: '', userName: '', })
	this.goShopIndex()
	window.location.reload()
}

// 传子分类id 得到该分类下面第一篇文章的内容
Vue.prototype.getArticleId = function (cate_id) {
	let that = this
	that.c_ajax({cate_id: cate_id, }, 'api.php/Cms/lists?visit=public', function (value) {
		if (value.data.status === 10001) {
			that.goArticleDetail(value.data.lists[0].id)
		}
	})
}

//时间戳转时间 3个组合
Vue.prototype.timestampToTime = function (timestamp) {
	let d = new Date(timestamp * 1000), gm = d.getMonth() + 1, gd = d.getDate(), gh = d.getHours(), gmi = d.getMinutes(), gs = d.getSeconds()
	return d.getFullYear() + '-' + this.add0(gm) + '-' + this.add0(gd) + " " + this.add00(this.add0(gh)) + ':' + this.add00(this.add0(gmi)) + ':' + this.add00(this.add0(gs))
}
Vue.prototype.add00 = function (t) {
	if (t === 0) {
		return "00"
	}
	return t
}
Vue.prototype.add0 = function (t) {
	if (t >= 1 && t <= 9) {
		return "0" + t
	}
	return t
}
//提取链接里的name
Vue.prototype.getQueryString = function (name) {
	let after = window.location.hash.split("?")[1]
	if (after) {
		let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)")
		let r = after.match(reg)
		if (r !== null){
			return decodeURIComponent(r[2])
		} else {
			return null
		}
	} else {
		return null
	}
}


// WEBPACK FOOTER //
// ./src/global_methods.js